const validate = {
  rules: {
    setor_id: {
      required: true,
    },
    nome: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
    whatsapp: {
      required: true,
    },
  },
  messages: {
    setor_id: "O setor é obrigatório.",
    nome: "O nome é obrigatório.",
    email: {
      required: "O email é obrigatório.",
      email: "O email é inválido",
    },
    whatsapp: "O whatsapp é obrigatório.",
  },
};

export default validate;
